import { Title } from "../title";

export interface TableType {
  id: number;
  yearMonth: string;
  patientEnrollCount: number;
  avgHccRisk: number;
  totalCost: number;
  hospitalAdmissions: number;
  reAdmissions: number;
  erAdmissions: number;
  erVisits: number;
}

export const tableColumns = [
  {
    title: "YEAR - MONTH",
    dataIndex: "yearMonth",
    key: "yearMonth",
    className: "textAlignLeft",
    width: "10%",
    sorter: (a: TableType, b: TableType) => a.id - b.id,
  },
  {
    title: "PATIENT/ENROLL COUNT",
    dataIndex: "patientEnrollCount",
    key: "patientEnrollCount",
    className: "textAlignRight",
    width: "10%",
    render: (text: any) => text.toLocaleString(),
  },
  {
    title: "AVG. HCC RISK",
    dataIndex: "avgHccRisk",
    key: "avgHccRisk",
    width: "9%",
    className: "textAlignRight",
    render: (text: any) => text.toLocaleString(),
  },
  {
    title: "TOTAL COST",
    dataIndex: "totalCost",
    key: "totalCost",
    width: "14%",
    className: "textAlignRight",
    render: (text: any) => (
      <Title suffix="$" text={text.toLocaleString()} />
    ),
  },
  {
    title: <p>HOSPITAL ADMISSIONS<br/><span className="sub-label_col-label">(Per 1000 Members)</span></p>,
    dataIndex: "hospitalAdmissions",
    key: "hospitalAdmissions",
    width: "11.75%",
    className: "textAlignRight",
    // render: (text: any) => text.toLocaleString(),
  },
  {
    title: <p>RE-ADMISSIONS<br/><span className="sub-label_col-label">(Per 100 Members)</span></p>,
    dataIndex: "reAdmissions",
    width: "11.75%",
    className: "textAlignRight",
    key: "reAdmissions",
    // render: (text: any) => text.toLocaleString(),
  },
  {
    title: <p>ER ADMISSIONS<br/><span className="sub-label_col-label">(Per 100 Members)</span></p>,
    dataIndex: "erAdmissions",
    key: "erAdmissions",
    width: "11.75%",
    className: "textAlignRight",
    // render: (text: any) => text.toLocaleString(),
  },
  {
    title: <p>ER VISITS<br/><span className="sub-label_col-label">(Per 1000 Members)</span></p>,
    dataIndex: "erVisits",
    key: "erVisits",
    width: "11.75%",
    className: "textAlignRight",
    // render: (text: any) => text.toLocaleString(),
  },
];

export const sideCardTableColumn = [
  {
    title: "PMPM",
    tableColumn: "totalCost",
  },
  {
    title: "HCC Risk",
    tableColumn: "avgHccRisk",
  },
  {
    title: "Hospital Admissions",
    tableColumn: "hospitalAdmissions",
  },
  {
    title: "ER Admissions",
    tableColumn: "erAdmissions",
  },
  {
    title: "Re Admissions",
    tableColumn: "reAdmissions",
  },
  {
    title: "ER Visits",
    tableColumn: "erVisits",
  },
];
